import { grey } from "@mui/material/colors";
import { SxProps } from "@mui/system";

export const formStyles: Record<string, SxProps> = {
  heading: {
    mt: 4,
    // heading style
    px: 2,
    py: 1,
    bgcolor: grey[300],
    borderRadius: 1,
  },

  selectDropdown: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    fontSize: "0.8125rem",
    // color: "#364152",
    fontWeight: "400",
    borderRadius: "12px",
    // "& > div": {
    //   background: "none",
    //   color: "black",
    //   borderRadius: "12px",
    //   fontSize: "0.8125rem",
    //   fontWeight: "400",
    // },
    // "& fieldset": {
    //   color: "black",
    //   borderRadius: "8px",
    // },
  },
};
